import { makeApiTypes } from 'sidecar-utility-library'

export const types = {
  ...makeApiTypes('CARD_ACTIVATION_DATA', 'member'),
  ...makeApiTypes('DECIDE_ON_EXCLUSIONS', 'member'),
  ...makeApiTypes('FETCH_AUTHED_USER', 'member'),
  ...makeApiTypes('FETCH_MEMBERS', 'member'),
  ...makeApiTypes('FETCH_PAYMENT_CARDS', 'member'),
  ...makeApiTypes('UPDATE_AUTOPAY_EXPENSE', 'member'),
  ...makeApiTypes('FETCH_TOKEN_STATUS', 'member'),
  ...makeApiTypes('FORGOT_PASSWORD', 'member'),
  ...makeApiTypes('REAPPLY_MEMBER', 'member'),
  ...makeApiTypes('RESET_PASSWORD', 'member'),
  ...makeApiTypes('REINSTATE_MEMBER', 'member'),
  ...makeApiTypes('UNDO_CANCELLATION', 'member'),
  ...makeApiTypes('UPDATE_MEMBER', 'member'),
  ...makeApiTypes('ASSIGN_OWNER', 'member'),
  ...makeApiTypes('UPDATE_PASSWORD', 'member'),
  ...makeApiTypes('UPDATE_MEMBER_POLICY', 'member'),
  ...makeApiTypes('FETCH_MEMBER_SERVICE_LIMITS', 'expense'),
  ...makeApiTypes('FETCH_SERVICE_LIMIT_DETAILS', 'member'),
  ...makeApiTypes('FETCH_SERVICE_LIMIT_DATES', 'member'),
  ...makeApiTypes('FETCH_ACCRUABLES', 'member'),
  ...makeApiTypes('FETCH_BENEFIT_DETAILS', 'member'),
  ...makeApiTypes('FETCH_ACCRUABLE_DATES', 'member'),
  ...makeApiTypes('FETCH_MEMBER_BENEFIT_CARDS', 'member'),
  ...makeApiTypes('FETCH_MEMBER_ID_CARD', 'member'),
  ...makeApiTypes('UPDATE_PHI_COMMUNICATION_PREFERENCE', 'member'),

  CLEAR_PAYMENT_CARDS: 'member/CLEAR_PAYMENT_CARDS',
  SET_SELECTED_MEMBER_UUID: 'member/SET_SELECTED_MEMBER_UUID',
}

export const initialState = {
  cardActivation: {
    busy: false,
    error: '',
    tokens: {},
    status: {},
  },
  cards: {
    busy: false,
    error: '',
    entities: [],
  },
  benefitCards: {
    busy: false,
    error: '',
    entity: {},
  },
  dependents: [],
  members: {
    busy: false,
    error: '',
    entities: {},
  },
  primaryMember: {},
  // using a specific authedUserBusy because members.busy gets
  // toggled more than we need. I'm adding it here to know when
  // we're specifically only fetching for the authed user.
  authedUserBusy: false,
  resetPassword: {
    busy: false,
    error: '',
    message: '',
  },
  updatePassword: {
    busy: false,
    error: '',
  },
  memberServiceLimits: {
    busy: false,
    error: null,
    entity: {},
  },
  accountServiceLimits: {
    busy: false,
    error: null,
    entities: [],
  },
  serviceLimitDetails: {
    busy: false,
    error: null,
    entity: {},
  },
  serviceLimitDates: {
    busy: false,
    error: null,
    entities: [],
  },
  accruables: {
    busy: false,
    error: null,
    entity: {},
  },
  accruableDates: {
    busy: false,
    error: null,
    entity: {},
  },
  memberIdCard: {
    busy: false,
    error: null,
    entity: {},
  },
  phiCommunicationPreference: {
    busy: false,
    error: null,
  },
  selectedMemberUuid: null,
}
